/* eslint-disable */
import { Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState, useRef, useCallback } from "react";
import styles from "./AmarantComponent.module.scss";
import {
  listErrors,
  getUserInfo,
  editUserInfo,
  sendTemplate,
} from "../../actions/amarantFields";
import { getTicketsForSystem, editCustomerName } from "../../actions/tickets";
import { connect } from "react-redux";
import moment from "moment";
import VehiclesComponent from "./VehiclesComponent";
import PoliciesComponent from "./PoliciesComponent";
import VignettesComponent from "./VignettesComponent";
import FinesComponent from "./FinesComponent";
import ErrorsComponent from "./ErrorsComponent";
import HistoryComponent from "./HistoryComponent";
import VerifiedModal from "./VerifiedModal";
import OldTicketsModal from "./OldTicketsModal";
import RequestModal from "./RequestModal";
import useKeyPress from "../../utils/KeyboardShortcuts";
import { useNavigate } from "react-router";
import DocumentsComponent from "./DocumentsComponent";
import PaymentIntentsComponent from "./PaymentIntentsComponent";
import { Box } from "@mui/material";

const buttonNames = [
  "amarant:tabVehicles",
  "amarant:tabPolicies",
  "amarant:tabVignettes",
  "amarant:tabFines",
  "amarant:tabErrors",
  "amarant:tabHistory",
  "amarant:tabDocuments",
  "amarant:tabPayments",
];

// List of unrestricted contacts
const unrestrictedContacts = [
  "+359889335580",
  "mexusbg@gmail.com",
  "ben669@abv.bg",
  "+359894448525",
  "+359888397557",
  "+359896780237",
  "+359894448541",
  "+359889055798",
];

function AmarantComponent({
  listErrors,
  getUserInfo,
  editUserInfo,
  sendTemplate,
  user,
  errors,
  totalErrors,
  totalPages,
  getTicketsForSystem,
  tickets,
  editCustomerName,
  selectedTab,
  setSelectedTab,
}) {
  const { t } = useTranslation();
  const tableRef = useRef();
  const [openVerifiedModal, setOpenVerifiedModal] = useState(false);
  const [openOldTicketsModal, setOpenOldTicketsModal] = useState(false);
  const [requestModal, setRequestModal] = useState(false);
  const customerID = window.location.href.split("/")[5];
  const navigate = useNavigate();

  useEffect(() => {
    getUserInfo({
      //customerSupportId: "6231bc7bc8696d0016d4af13",
      customerSupportId: customerID,
      onSuccess: (res) => {
        getTicketsForSystem({
          system: "61ee8b87a07ddf1eb8268265",
          noPagination: true,
          customers: [customerID],
          customerAll: true,
        });
        listErrors({
          //customerSupportId: "6231bc7bc8696d0016d4af13",
          customerSupportId: customerID,
          pageNumber: 1,
        });
      },
    });
  }, []);

  const onKeyPress = (event) => {
    if (event.key === "Escape") {
      navigate(-1);
    }
  };

  useKeyPress(["Escape"], onKeyPress);

  // Check if the user has unrestricted access
  const hasUnrestrictedAccess = () => {
    try {
      // Get logged-in user data from localStorage
      const credentials = localStorage.getItem("credentials");
      const userFromStorage = localStorage.getItem("user");

      const parsedCredentials = credentials ? JSON.parse(credentials) : null;
      const parsedUser = userFromStorage ? JSON.parse(userFromStorage) : null;

      if (!parsedCredentials && !parsedUser) return false;

      // Check logged-in user data
      const loggedInUserEmail =
        parsedCredentials?.user?.email || parsedUser?.email;
      const loggedInUserPhone =
        parsedCredentials?.user?.phoneNumber || parsedUser?.phoneNumber;

      const isUnrestricted =
        unrestrictedContacts.includes(loggedInUserEmail) ||
        unrestrictedContacts.includes(loggedInUserPhone);

      return isUnrestricted;
    } catch (error) {
      console.error("Error checking access:", error);
      return false;
    }
  };
  // CHANGE: Removed access restrictions
  const isUnrestricted = true
  // const visibleButtonNames = isUnrestricted
  // ? buttonNames
  // : buttonNames.slice(0, -1);
  const visibleButtonNames = buttonNames; // Show all buttons without restrictions
console.log(visibleButtonNames);
  return (
    <div className={styles["amarant-container"]}>
      <div className={styles["upper-info-container"]}>
        <p style={{ marginLeft: "1%" }}>
          {t("amarant:userLabel")} <b>{user?.name + " " + user?.lastName}</b>
        </p>
        <Divider
          style={{
            backgroundColor: "#0DC1CE",
            height: window.innerWidth < 900 ? "2px" : 40,
            width: window.innerWidth < 900 ? "98%" : "unset",
            marginLeft: "1%",
          }}
          orientation={window.innerWidth < 900 ? "horizontal" : "vertical"}
        />
        <p style={{ marginLeft: "1%" }}>
          {t("amarant:phoneLabel")} <b>{user?.phoneNumber}</b>
        </p>
        <Divider
          style={{
            backgroundColor: "#0DC1CE",
            height: window.innerWidth < 900 ? "2px" : 40,
            width: window.innerWidth < 900 ? "98%" : "unset",
            marginLeft: "1%",
          }}
          orientation={window.innerWidth < 900 ? "horizontal" : "vertical"}
        />
        <p style={{ marginLeft: "1%" }}>
          {t("amarant:emailLabel")} <b>{user?.email}</b>
        </p>
        <Divider
          style={{
            backgroundColor: "#0DC1CE",
            height: window.innerWidth < 900 ? "2px" : 40,
            width: window.innerWidth < 900 ? "98%" : "unset",
            marginLeft: "1%",
          }}
          orientation={window.innerWidth < 900 ? "horizontal" : "vertical"}
        />
        <p style={{ marginLeft: "1%" }}>
          {t("amarant:registeredLabel")}{" "}
              <b>{moment(user?.createdAt).format("DD.MM.YYYY")}</b>
        </p>
        <Divider
          style={{
            backgroundColor: "#0DC1CE",
            height: window.innerWidth < 900 ? "2px" : 40,
            width: window.innerWidth < 900 ? "98%" : "unset",
            marginLeft: "1%",
          }}
          orientation={window.innerWidth < 900 ? "horizontal" : "vertical"}
        />
        <p style={{ marginLeft: "1%" }}>
          {t("amarant:subscriptionLabel")}{" "}
          <b>
            {user?.subscriptionValidUntil
              ? moment(user?.subscriptionValidUntil).isAfter(moment())
                ? t("amarant:activeUntil", {
                    date: moment(user?.subscriptionValidUntil).format(
                      "DD.MM.YYYY | HH:mm"
                    ),
                  })
                : t("amarant:expiredOn", {
                    date: moment(user?.subscriptionValidUntil).format(
                      "DD.MM.YYYY | HH:mm"
                    ),
                  })
              : t("no")}
          </b>
        </p>

        <Divider
          style={{
            backgroundColor: "#0DC1CE",
            height: window.innerWidth < 900 ? "2px" : 40,
            width: window.innerWidth < 900 ? "98%" : "unset",
            marginLeft: "1%",
          }}
          orientation={window.innerWidth < 900 ? "horizontal" : "vertical"}
        />
        <div
          className={styles["helper-cont"]}
          style={{ display: "flex", marginLeft: "1%" }}
        >
          <p style={{ display: "flex" }}>
            {t("amarant:verifiedLabel")}{" "}
            <b style={{ marginLeft: "3%" }}>{user.agreement ? ` ${t("yes")}` : ` ${t("no")}`}</b>
          </p>
          {user.agreement && (
            <div
              className={styles["info-icon"]}
              style={{
                width: "30px",
                height: window.innerWidth < 900 ? "20px" : "unset",
                marginLeft: "4%",
                display: user?.agreement === undefined && "none",
              }}
              onClick={() => setOpenVerifiedModal(true)}
            />
          )}
        </div>
        <Divider
          style={{
            backgroundColor: "#0DC1CE",
            height: window.innerWidth < 900 ? "2px" : 40,
            width: window.innerWidth < 900 ? "98%" : "unset",
            marginLeft: "1%",
          }}
          orientation={window.innerWidth < 900 ? "horizontal" : "vertical"}
        />
        <p style={{ marginLeft: "1%" }}>
          OS: <b style={{ textTransform: "uppercase" }}>{user?.os}</b>
        </p>
        <Divider
          style={{
            backgroundColor: "#0DC1CE",
            height: window.innerWidth < 900 ? "2px" : 40,
            width: window.innerWidth < 900 ? "98%" : "unset",
            marginLeft: "1%",
          }}
          orientation={window.innerWidth < 900 ? "horizontal" : "vertical"}
        />
        <div className={styles["helper-cont"]} style={{ display: "flex" }}>
          <p
            style={{ marginLeft: "2%", whiteSpace: "nowrap", display: "flex" }}
          >
            {t("amarant:previousTickets")}{" "}
            <b style={{ textTransform: "uppercase", marginLeft: "2%" }}>
              {tickets?.length}
            </b>
          </p>

          <div
            className={styles["info-icon"]}
            style={{
              width: "30px",
              marginLeft: "4%",
              height: window.innerWidth < 900 ? "20px" : "unset",
            }}
            onClick={() => setOpenOldTicketsModal(true)}
          />
        </div>
        <Divider
          style={{
            backgroundColor: "#0DC1CE",
            height: window.innerWidth < 900 ? "2px" : 40,
            width: window.innerWidth < 900 ? "98%" : "unset",
            marginLeft: "1%",
          }}
          orientation={window.innerWidth < 900 ? "horizontal" : "vertical"}
        />
        <div className={styles["helper-cont"]} style={{ display: "flex" }}>
          <p style={{ marginLeft: "4%", display: "flex" }}>Token:</p>
          <div
            className={styles["info-icon"]}
            style={{
              width: "30px",
              marginLeft: "4%",
              height: window.innerWidth < 900 ? "20px" : "unset",
            }}
            onClick={() => {
              setRequestModal(true);
            }}
          />
        </div>
      </div>
      <div className={styles["lower-info-container"]}>
        <div className={styles["buttons-container"]}>
          {visibleButtonNames.map((name, i) => {
            return (
              <div
                className={`${styles["button-container"]} ${
                  i === selectedTab && styles["active"]
                } ${i === 4 && totalErrors < 1 ? styles["inactive"] : null}`}
                id={i}
                key={i + 10}
                onClick={() => {
                  setSelectedTab(i);
                }}
              >
                {i === 4
                  ? t("amarant:tabWithCount", {
                      label: t(name),
                      count: totalErrors,
                    })
                  : t(name)}
              </div>
            );
          })}
        </div>
        <Box
          sx={{
            flex: 1,
            overflow: "hidden",
            minHeight: 0,
            paddingBottom: "20px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {selectedTab === 0 ? (
            <VehiclesComponent customerID={customerID} />
          ) : selectedTab === 1 ? (
            <PoliciesComponent customerID={customerID} />
          ) : selectedTab === 2 ? (
            <VignettesComponent customerID={customerID} />
          ) : selectedTab === 3 ? (
            <FinesComponent customerID={customerID} />
          ) : selectedTab === 4 ? (
            <ErrorsComponent
              errors={errors}
              tableRef={tableRef}
              totalPages={totalPages}
              listErrors={listErrors}
              customerID={customerID}
            />
          ) : selectedTab === 5 && user ? (
            <HistoryComponent user={user} />
          ) : selectedTab === 6 ? (
            <DocumentsComponent customerID={customerID} />
          ) : selectedTab === 7 ? (
            <PaymentIntentsComponent customerID={customerID} />
          ) : null}
        </Box>
      </div>
      <VerifiedModal
        open={openVerifiedModal}
        handleClose={() => setOpenVerifiedModal(false)}
        customerSupportID={customerID}
        editUserInfo={editUserInfo}
        currentUser={user}
        getUserInfo={getUserInfo}
        mobileModal={window.innerWidth < 900 && true}
        sendTemplate={sendTemplate}
        editCustomerName={editCustomerName}
      />
      <OldTicketsModal
        open={openOldTicketsModal}
        tickets={tickets}
        mobileModal={window.innerWidth < 900 && true}
        handleClose={() => setOpenOldTicketsModal(false)}
      />
      <RequestModal
        open={requestModal}
        handleClose={() => setRequestModal(false)}
        data={user?.token}
        pin={user?.passcode}
        _id={user?._id}
        mobileModal={window.innerWidth < 900 && true}
        token={true}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  errors: state.amarantFields.errors,
  user: state.amarantFields.user,
  currentTicket: state.tickets.currentTicket,
  tickets: state.tickets.tickets,
  totalErrors: state.amarantFields.totalErrors,
  totalPages: state.amarantFields.totalPages,
});

const mapDispatchToProps = (dispatch) => ({
  listErrors: (payload) => dispatch(listErrors(payload)),
  getUserInfo: (payload) => dispatch(getUserInfo(payload)),
  editUserInfo: (payload) => dispatch(editUserInfo(payload)),
  getTicketsForSystem: (payload) => dispatch(getTicketsForSystem(payload)),
  sendTemplate: (payload) => dispatch(sendTemplate(payload)),
  editCustomerName: (payload) => dispatch(editCustomerName(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AmarantComponent);
